// authService.ts
import { AuthenticationContext, adalFetch, withAdalLogin } from "react-adal";
 
export const adalConfig = {
  instance: "https://sso6.neu.edu.vn/",
  tenant: "adfs",
  clientId: "6de4b302-8ce4-419c-b3ae-30734ca5d304",  
  // clientId: "a6ad9561-f2a8-46cf-8e00-ee8ddb1a44b8",

  endpoints: {
    api: "https://localhost:44349/api/Auth/adfs",
  },
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  cacheLocation: "localStorage",
};

export const authContext = new AuthenticationContext(adalConfig);

export const getToken = async (): Promise<string> => {
  try {
    const token = await new Promise<string>((resolve, reject) => {
      authContext.acquireToken(
        adalConfig.endpoints.api,
        (error, acquiredToken) => {
          if (error || !acquiredToken) {
            reject(error || new Error("Failed to acquire token."));
          } else {
            resolve(acquiredToken);
          }
        }
      );
    });

    return token;
  } catch (error) {
    console.error("Error acquiring token:", error);
    throw error;
  }
};

export const adalApiFetch = (fetch: any, url: string, options?: any) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(
  authContext,
  adalConfig.endpoints.api
);
